import React from 'react';

/**
 * Error boundary specifico per il modulo onboarding (SetupFloatingBubble,
 * useDriverTour, useContextualTourTrigger).
 *
 * Filosofia: l'onboarding e' un'overlay opzionale. Se crasha (LLM unhandled
 * error, RPC race, driver.js DOM glitch, ecc.) NON deve mai rompere l'app
 * principale. Cattura l'errore, lo logga in console, e ritorna `null` cosi
 * l'utente continua a usare il CRM normalmente.
 *
 * Niente UI di fallback: la bubble e' decorativa, non va sostituita da un
 * banner d'errore che disturberebbe piu del problema.
 */

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class OnboardingErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.warn(
      '[OnboardingErrorBoundary] Caught error, hiding onboarding overlay:',
      error.message,
      info.componentStack,
    );
  }

  render(): React.ReactNode {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
